<template>
  <div class="home">
    <div class="header">
      <h1>
        <a
          href="//scjg.hubei.gov.cn/index.shtml"
          class="nt"
          style="width: 100%"
          title=""
        ></a>
      </h1>

      <div class="search-form" style="margin-bottom: 20px;">
        <h2></h2>
        <el-form :model="queryForm" label-width="150px">
          <el-row
            :gutter="20"
            type="flex"
            style="flex-wrap: wrap"
            class="flex-row"
          >
            <el-col class="wat">
              <el-form-item label="企业名称：">
                <el-input
                  v-model="queryForm.qymc"
                  placeholder="请输入企业名称"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="wat">
              <el-form-item label="统一社会信用代码：">
                <el-input
                  v-model="queryForm.tyshxydm"
                  placeholder="请输入统一社会信用代码"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="wat">
              <el-form-item label="发证机关：">
                <el-input
                  v-model="queryForm.fzjg"
                  placeholder="请输入发证机关"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="wat">
              <el-form-item label="许可证编号：">
                <el-input
                  v-model="queryForm.zsbh"
                  placeholder="请输入许可证编号"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row type="flex" style="flex-wrap: wrap" class="flex-row">
          <el-col :xs="24" :sm="4">
            <el-button
              @click="clickQuery"
              class="search-btn cx"
              type="primary"
              style="width: 40%"
              >查 询</el-button
            >
            <el-button
              @click="resetQuery"
              class="search-btn cz"
              type="info"
              style="width: 40%"
              >重 置</el-button
            >
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="table" style="margin-top: 20px;">
      <div
        style="text-align: left;font-size: 18px;max-width: 1920px;margin: 0 auto;margin-bottom: 20px;"
      >
        备注：数据更新周期为12小时。
      </div>
      <el-table :data="tableData" header-row-class-name="tab-head">
        <el-table-column prop="LIC_YCER_NAME" label="证书类型" align="center">
        </el-table-column>
        <el-table-column prop="LIC_NUMBER" label="证书编号" align="center">
        </el-table-column>
        <el-table-column
          prop="LIC_HOLDER"
          label="企业名称"
          width="300"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column prop="LIC_UNITNAME" label="发证机关" width="300" align="center">
                </el-table-column> -->
        <el-table-column
          prop="LIC_DATE"
          label="发证日期"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" width="300" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="btnClick(scope.row, 1)"
              >正 本</el-button
            >

            <el-button
              type="primary"
              v-if="scope.row.FB"
              size="small"
              @click="btnClick(scope.row, 2)"
              >副 本</el-button
            >
            <el-button
              v-if="scope.row.MX"
              type="primary"
              size="small"
              @click="btnClick(scope.row, 3)"
              >明细表</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagesall">
      <div class="page-total">
        <span>
          共
          <span class="total">{{ allTotal }}</span>
          条
        </span>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :total="pageTotal"
        :current-page="queryPage.currentPage"
        :page-sizes="[10, 50, 100]"
        :page-size="queryPage.pageSize"
        layout="prev, pager, next, sizes, jumper"
        style="margin-bottom: 20px"
      >
      </el-pagination>
    </div>
    <el-dialog title="提示" :visible.sync="isShowDialog" width="30%" center>
      <el-table :data="ggList">
        <el-table-column prop="FILE_NAME" label="广告样件" align="center">
        </el-table-column>
        <el-table-column label="操作" width="300" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="downLoadClick(scope.row)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDialog = false" type="primary"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
    <iframe
      src="https://scjg.hubei.gov.cn/fzlm/qtlm/yw/index.shtml"
      frameborder="0"
      style="width: 100%; height: 202px"
    ></iframe>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import http from "@/http/index.js";
export default {
  name: "Home",
  // components: {
  //   HelloWorld
  // }
  data() {
    return {
      queryForm: {
        qymc: "",
        tyshxydm: "",
        fzjg: "",
        zsbh: "",
      },
      queryPage: {
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [],
      pageTotal: 10,
      allTotal: 10,
      zsmc: "",
      isParmasQuery: false,
      ggList: [],
      ggTotalSize: "",
      isShowDialog: false,
    };
  },
  created() {},
  mounted() {
    const param = this.geturlparam(window.parent.location.href);
    this.zsmc = decodeURI(param.zsmc);
    this.initQury();
    // this.setTotal();
  },
  methods: {
    async setTotal() {
      const req = {
        pageSize: this.queryPage.pageSize,
        currentPage: this.queryPage.currentPage,
      };

      const param = JSON.stringify(req);
      const findDgsLicListResp = await http.user.findDgsLicList({
        param,
        method: "POST",
      });
      const { code, content } = await http.user.cslcldAllNum(
        req,
        findDgsLicListResp
      );
      if (code == true || code == 200) {
        this.allTotal = content[0]["COUNT(1)"];
      }
    },
    geturlparam(url) {
      if (url.indexOf("?") <= -1) {
        return false;
      }
      // window.location.href 获取地址 实际项目中是这样获取url？后面的参数的，这里为了展示就自己在函数中定义了
      let p = url.split("?")[1]; //截取问号后面参数
      let keyValue = p.split("&"); //以&为分割转换成数组
      let obj = {}; //用来接收参数的
      for (let i = 0; i < keyValue.length; i++) {
        let item = keyValue[i].split("="); //继续分割
        obj[item[0]] = item[1]; //type为键，1为值给obj对象
      }
      return obj;
    },
    // 初始化查询
    async initQury() {
      this.isParmasQuery = false;
      const req = {
        // zsmc: this.zsmc,
        pageSize: this.queryPage.pageSize,
        currentPage: this.queryPage.currentPage,
      };

      const param = JSON.stringify(req);
      const findDgsLicListResp = await http.user.findDgsLicList({
        param,
        method: "POST",
      });

      const { code, content, totalSize } = await http.user.xcyAllQuery(
        req,
        findDgsLicListResp
      );
      // code有数字和true的情况
      if (code == true || code == 200) {
        this.tableData = content;
        this.pageTotal = totalSize;
      }
    },
    // 按需查询
    queryPamarsm() {},
    // 分页
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.queryPage.pageSize = val;
      if (!this.isParmasQuery) {
        this.initQury();
      } else {
        this.queryPamarSwarch();
      }
    },
    // 分页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.queryPage.currentPage = val;
      if (!this.isParmasQuery) {
        this.initQury();
      } else {
        this.queryPamarSwarch();
      }
    },
    // 重置查询
    resetQuery() {
      this.queryPage = this.$options.data().queryPage;
      this.queryForm = this.$options.data().queryForm;
      this.initQury();
    },
    // 按钮事件
    btnClick(data, type) {
      const white = [
        "食品经营许可证",
        "食品生产许可证",
        "小餐饮经营许可证",
        "食品生产加工小作坊生产许可证",
      ];
      if (type == 1) {
        if (
          data.ZB &&
          data.ZB.indexOf(
            "https://59.175.169.149:88/SearchCardController.do?goCardList"
          ) > -1 &&
          white.includes(this.zsmc)
        ) {
          this.$message.warning("未查询到证书版式文件，请咨询审批机关");
          return;
        }
        window.open(data.ZB);
      } else if (type == 2) {
        if (
          data.FB &&
          data.FB.indexOf(
            "https://59.175.169.149:88/SearchCardController.do?goCardList"
          ) > -1 &&
          white.includes(this.zsmc)
        ) {
          this.$message.warning("未查询到证书版式文件，请咨询审批机关");
          return;
        }
        window.open(data.FB);
      } else {
        if (
          data.MX &&
          data.MX.indexOf(
            "https://59.175.169.149:88/SearchCardController.do?goCardList"
          ) > -1 &&
          white.includes(this.zsmc)
        ) {
          this.$message.warning("未查询到证书版式文件，请咨询审批机关");
          return;
        }
        window.open(data.MX);
      }
    },
    // 点击查询初始化
    async queryPamarSwarch() {
      if (
        !this.queryForm.qymc &&
        !this.queryForm.tyshxydm &&
        !this.queryForm.fzjg &&
        !this.queryForm.zsbh
      ) {
        this.initQury();
        return;
      }
      const req = {
        // zsmc: this.zsmc,
        pageSize: this.queryPage.pageSize,
        currentPage: this.queryPage.currentPage,
        // zsbh: this.queryForm.zsbh,`
        tyshxydm: this.queryForm.tyshxydm,
        // qymc: `%${this.queryForm.qymc}%`,
        fzjg: this.queryForm.fzjg,
      };
      if (this.queryForm.zsbh) {
        let zsbh = this.queryForm.zsbh.replace(/\(/g, "（");
        zsbh = zsbh.replace(/\)/g, "）");
        req.zsbh = zsbh;
      }

      if (this.queryForm.qymc) {
        req.qymc = `%${this.queryForm.qymc}%`;
      } else {
        req.qymc = "";
      }
      const param = JSON.stringify(req);
      const findDgsLicListResp = await http.user.findDgsLicList({
        param,
        method: "POST",
      });

      const { code, content, totalSize } = await http.user.xcyParamQuery(
        req,
        findDgsLicListResp
      );
      if (code == true || code == 200) {
        this.tableData = content;
        this.pageTotal = totalSize;
      }
    },
    // 点击查询
    async clickQuery() {
      this.isParmasQuery = true;
      this.queryPage.pageSize = 10;
      this.queryPage.currentPage = 1;
      this.queryPamarSwarch();
    },
    // 广告查询详情
    async reviewClick(row) {
      const req = {
        LIC_ID: row.LIC_ID,
        currentPage: 1,
        pageSize: 100,
      };
      const param = JSON.stringify(req);
      const findDgsLicListResp = await http.user.ggspXzspFile({
        param,
        method: "POST",
      });
      const { code, content, totalSize } = await http.user.licmaininfobyparam(
        req,
        findDgsLicListResp
      );
      if (code == true || code == 200) {
        this.ggList = content;
        this.ggTotalSize = totalSize;
        this.isShowDialog = true;
      }
    },
    // 下载广告文案
    downLoadClick(row) {
      // 使用a标签下载文件 也可以在图表直接使用a标签下载
      const link = document.createElement("a");
      link.href = row.HTTP;
      link.download = row.FILE_NAME;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>
<style>
@media (max-width: 1200px) {
  body {
    width: 1600px;
  }
  :v-deep .table {
    width: 100%;
  }
}
</style>
<style scoped>
body {
  background-color: #fff;
}
.header h1 {
  width: 100%;
  height: 70px;
  background: linear-gradient(to bottom, #f2faff, #f3faff);
  box-shadow: 0px 0px 20px rgba(2, 60, 132, 0.3);
  z-index: 999;
  position: relative;
}

.header h1 a {
  display: block;
  height: 70px;
  background: url(//scjg.hubei.gov.cn/material/images/xkzcx_logo.png) 17px 50%
    no-repeat;
}
.search-form {
  width: 100%;
  height: 300px;
  margin-bottom: 37px;
  background: url(//scjg.hubei.gov.cn/material/images/xkzcx_bg.jpg) 50% 100%
    no-repeat;
  overflow: hidden;
}
.search-form h2 {
  width: 100%;
  height: 90px;
  background: url(//scjg.hubei.gov.cn/material/images/scjgcx/cslcld.png) 50% 50%
    no-repeat;
  margin-top: 36px;
  margin-bottom: 19px;
}
::v-deep .tab-head {
  background: #edf6fe;
  color: #224b7f;
  line-height: 60px;
}
::v-deep .tab-head th {
  padding: 0px;
  background: #edf6fe;
  border-bottom: none !important;
}
::v-deep .flex-row {
  display: flex;
  justify-content: center;
  width: 100%;
}
::v-deep .el-form-item {
  display: flex;
  align-items: center;
}
::v-deep .el-form-item__label {
  width: auto !important;
  font-size: 18px;
  color: #333;
}
::v-deep .el-form-item__content {
  margin-left: 0px !important;
}
::v-deep .wat {
  width: auto;
}
::v-deep .el-input__inner {
  border: 1px solid #6b9eec;
  border-radius: 0px;
}
::v-deep .el-input__inner::placeholder {
  color: #666666;
}
::v-deep .search-btn {
  width: 96px !important;
  height: 42px;
  border-radius: 0px;
  color: #fff;
  border: none;
}
::v-deep .cx {
  background-color: #002f7c;
}
::v-deep .cz {
  background-color: #fd844e;
  margin-left: 20px;
}
::v-deep .el-pagination__sizes {
  margin: 0 0 0 10px;
}
::v-deep .detail-dialog .el-dialog__header {
  padding: 16px 24px;
  border-bottom: 1px solid rgba(5, 5, 5, 0.06);
  text-align: left;
}
::v-deep .detail-dialog .el-dialog__body {
  padding: 24px;
}
.scroll-container {
  padding: 6px;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.scrollbar__wrap {
  overflow-x: hidden;
  scrollbar-width: none;
  height: 100%;
  overflow: auto;
}
.table-box {
  height: 500px;
}
.my-table {
  width: 100%;
  table-layout: fixed;
  border-left: 1px solid #f0f0f0;
  border-top: 1px solid #f0f0f0;
}
.my-table > tr > th,
.my-table > thead > tr > th,
.my-table > tbody > tr > th,
.my-table > tfoot > tr > th,
.my-table > tr > td,
.my-table > thead > tr > td,
.my-table > tbody > tr > td,
.my-table > tfoot > tr > td {
  padding: 8px;
  border-right: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}
.my-table > tr:nth-child(2n),
.my-table > tbody > tr:nth-child(2n) {
  background-color: #fafafa;
}
::v-deep .el-table tr:nth-child(2n) {
  background-color: #fafafa;
}
.font-600 {
  font-weight: 600;
}
.text-left {
  text-align: left;
}
.text-blue {
  color: #0986b0;
}
.pagesall {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
}
.page-total {
  height: 32px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.nt {
  text-align: left;
  letter-spacing: -3em;
  overflow: hidden;
}

.header-title {
  font-size: 17pt;
  font-weight: 600;
  margin-top: 30px;
  color: rgb(19, 90, 156);
}

.table {
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
}
</style>
